import React from "react";
import orderBy from "lodash/orderBy";
import { Label, Input, Button, Col, Row, FormGroup } from "reactstrap";
import ReactSelect from "react-select";
import ReactTable from "@dhn/components/molecules/data-table";
import EnabledButton from "../../../../../../../@dhn/components/molecules/button-enabled";
import {
  isNoInsuredArs,
  NO_INSURED_ARS_ID,
} from "../../../../utils/branch-office-ars";

export default function InsurersSubTab({
  optionArs,
  state,
  onChange,
  arsesSelected,
  onAddAndModifyArs,
  isNew,
}) {
  const arsMapFilter = optionArs?.filter(
    (item) =>
      Number(item?.id) !== NO_INSURED_ARS_ID &&
      !(state || []).some(
        (currentArs) => Number(currentArs?.arsId) === Number(item?.id),
      ),
  );
  const noInsuredSelected = isNoInsuredArs(arsesSelected?.arsId);

  const renderCode = (original, key) =>
    isNoInsuredArs(original.arsId) ? "No aplica" : original[key];

  return (
    <div className="animated fadeIn">
      <Row form className="d-flex align-items-end my-3">
        <Col md={2}>
          <Label>Aseguradora</Label>
          <ReactSelect
            placeholder="Seleccionar ARS"
            className="w-100"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item}
            options={arsMapFilter || []}
            value={
              optionArs?.find(
                (item) => Number(item?.id) === Number(arsesSelected?.arsId),
              ) || null
            }
            onChange={(item) =>
              onChange("arsId", Number(item.id), "arsesSelected")
            }
          />
        </Col>
        <Col md={2}>
          <Label>Código PSS</Label>
          <Input
            value={arsesSelected?.codePSS || ""}
            onChange={({ target: { value } }) =>
              onChange("codePSS", value, "arsesSelected")
            }
            placeholder={noInsuredSelected ? "No aplica" : "Código PSS"}
            disabled={noInsuredSelected}
          />
        </Col>
        <Col md={2}>
          <Label>Código Usuario PSS</Label>
          <Input
            value={arsesSelected?.codeUserPSS || ""}
            onChange={({ target: { value } }) =>
              onChange("codeUserPSS", value, "arsesSelected")
            }
            placeholder={noInsuredSelected ? "No aplica" : "Cod. Usuario PSS"}
            disabled={noInsuredSelected}
          />
        </Col>
        <Col md={2}>
          <Label>Código P&amp;P</Label>
          <Input
            value={arsesSelected?.codePP || ""}
            onChange={({ target: { value } }) =>
              onChange("codePP", value, "arsesSelected")
            }
            placeholder={noInsuredSelected ? "No aplica" : "Código P&P"}
            disabled={noInsuredSelected}
          />
        </Col>
        <Col md={2} className="d-flex">
          <Button
            color="success"
            className="btn-color-success ml-1"
            onClick={() => onAddAndModifyArs()}
          >
            <i className="fa fa-plus align-self-center" aria-hidden="true" />
            {isNew ? " Agregar" : " Modificar"}
          </Button>
        </Col>
      </Row>

      <ReactTable
        data={orderBy(state, ["enabled", "name"], ["desc", "asc"])}
        className="-striped -highlight mt-2"
        defaultPageSize={10}
        columns={[
          {
            Header: "Aseguradora",
            Cell: ({ original: { arsId } }) =>
              optionArs?.find((item) => Number(item.id) === Number(arsId))?.name,
          },
          {
            Header: "Código",
            accessor: "code",
            headerClassName: "bg-light",
            columns: [
              {
                Header: "PSS",
                headerClassName: "bg-light",
                className: "text-center",
                Cell: ({ original }) => renderCode(original, "codePSS"),
              },
              {
                Header: "Usuario PSS",
                headerClassName: "bg-light",
                className: "text-center",
                Cell: ({ original }) => renderCode(original, "codeUserPSS"),
              },
              {
                Header: "P&P",
                headerClassName: "bg-light",
                className: "text-center",
                Cell: ({ original }) => renderCode(original, "codePP"),
              },
            ],
          },
          {
            Header: "Opciones",
            className: "text-center",
            Cell: ({ original }) => {
              if (isNoInsuredArs(original.arsId)) {
                return (
                  <Button type="button" color="success" disabled>
                    <i className="fa fa-lock" aria-hidden="true" />
                    {" Obligatoria"}
                  </Button>
                );
              }

              return (
                <FormGroup>
                  <Button
                    color="secondary"
                    type="button"
                    onClick={() => {
                      onChange("arsesSelected", original);
                      onChange("isNewArses", false);
                    }}
                    className="btn-color-gray card-header-action"
                  >
                    <i className="fa fa-pencil" />
                    {" Editar"}
                  </Button>
                  <EnabledButton
                    status={original.enabled}
                    onClick={() => onAddAndModifyArs(original)}
                  />
                </FormGroup>
              );
            },
          },
        ]}
      />
    </div>
  );
}
